<div [hidden]="!loading">
    <div class="loading-spinner progress-loader position-fixed w-100 justify-content-center align-items-center">
      <div class="loader-container">
        <img class="align-self-end mx-auto"
            [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'"
            onerror="this.src='assets/images/logo.png';" alt="...">
        <span class="text-center align-self-start font-size-21 font-weight-bold">{{loadingMessage}}</span>
      </div>
    </div>
</div>
